import * as React from 'react';
import * as styles from "./TabBar.css";
import { AppStore } from '../stores';
import { inject, observer } from 'mobx-react';
import { TabBarItem } from './tabBarItem/TabBarItem';

export interface ITabBarProps {
  store?: AppStore;
  selectPage: (index: number) => void;
}

@inject('store')
@observer
export class TabBar extends React.Component<ITabBarProps> {

  public render(): JSX.Element {
    let highlightMoreButton = true;
    const menu = [];
    this.props.store.instance.settings.menu.forEach((tab: any, index) => {
      if (index < 4) {
        if (index === this.props.store.selectedPageIndex) {
          highlightMoreButton = false;
        }
      }
      let marginLeft: string = "0";
      if (index === 0) {
        if (this.props.store.instance.settings.menu.length === 1) {
          marginLeft = "40%";
        }
        if (this.props.store.instance.settings.menu.length === 2) {
          marginLeft = "30%";
        }
        if (this.props.store.instance.settings.menu.length === 3) {
          marginLeft = "20%";
        }
        if (this.props.store.instance.settings.menu.length === 4) {
          marginLeft = "10%";
        }
      }
      if ((this.props.store.instance.settings.menu.length <= 5 || index < 4)) {
        const component = tab.components[0];
        const isMsalApp = window.location.href.includes("mobile-spa-msal");
        const isEmbeddedAndSharePoint = component && component.type === "EmbeddedPage" && component.url?.includes("sharepoint.com");

        if (component && (component.type === "ExternalLink" || (isMsalApp && isEmbeddedAndSharePoint)) && !this.props.store.preview) {
          menu.push(
            <a
              href={tab.components[0].url}
              target={"_blank"}
              data-interception="off"
              key={`tab_${index}`}
            >
              <TabBarItem
                icon={tab.icon}
                title={tab.title}
                iconColor={this.props.store.selectedPageIndex === index ? this.props.store.instance.settings.design.tabBarHighlightColor : this.props.store.instance.settings.design.tabBarContentColor}
                titleColor={this.props.store.selectedPageIndex === index ? this.props.store.instance.settings.design.tabBarHighlightColor : this.props.store.instance.settings.design.tabBarContentColor}
                style={{ marginLeft: marginLeft }}
                onClick={() => {
                  if (this.props.store.preview) {
                    this.props.store.selectedPageIndex = index;
                    if (this.props.selectPage) {
                      this.props.selectPage(index);
                    }
                  }
                }}
              />
            </a>
          );
        } else {
          menu.push(
            <TabBarItem
              key={`tab_${index}`}
              icon={tab.icon}
              title={tab.title}
              iconColor={this.props.store.selectedPageIndex === index ? this.props.store.instance.settings.design.tabBarHighlightColor : this.props.store.instance.settings.design.tabBarContentColor}
              titleColor={this.props.store.selectedPageIndex === index ? this.props.store.instance.settings.design.tabBarHighlightColor : this.props.store.instance.settings.design.tabBarContentColor}
              style={{ marginLeft: marginLeft }}
              onClick={() => {
                this.props.store.contentMapPageToShow = undefined;
                if (this.props.store.selectedPageIndex === index) {
                  this.props.store.reloadPage();
                } else {
                  this.props.store.selectedPageIndex = index;
                  if (this.props.selectPage) {
                    this.props.selectPage(index);
                  }
                  this.props.store.showMenu = false;
                  document.getElementById("IA_contentArea").scrollTop = 0
                  this.forceUpdate();
                }
              }}
            />
          );
        }
      }
    });
    if (this.props.store.instance.settings.menu.length > 5) {
      menu.push(
        <TabBarItem
          key={`tab_more`}
          style={{
            opacity: this.props.store.showPowerApp ? 0.5 : 1
          }}
          icon={"More"}
          title={undefined}
          iconColor={highlightMoreButton ? this.props.store.instance.settings.design.tabBarHighlightColor : this.props.store.instance.settings.design.tabBarContentColor}
          titleColor={highlightMoreButton ? this.props.store.instance.settings.design.tabBarHighlightColor : this.props.store.instance.settings.design.tabBarContentColor}
          onClick={() => {
            if(!this.props.store.showPowerApp ) {
              this.props.store.showMenu = !this.props.store.showMenu;
            }
          }}
        />
      );
    }
    let top = window.platform === "android" ? "calc(100vh - 50px)" : this.props.store.isIPhoneXType ? "calc(100vh - 70px)" : "calc(100vh - 50px)";
    if (this.props.store.preview) {
      top = "670px";
    }
    return (
      <div
        className={styles.IA_tabBar}
        style={{
          backgroundColor: this.props.store.instance.settings.design.tabBarColor,
          height: this.props.store.isIPhoneXType ? 70 : 50,
          top: top
        }}
      >
        {menu}
      </div >
    );
  }
}